"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MicrophoneOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16 4.19a2.93 2.93 0 0 1 2.84 3v8.62a2.93 2.93 0 0 1-2.83 3 2.92 2.92 0 0 1-2.82-3V7.19a2.92 2.92 0 0 1 2.81-3M16 2a5.07 5.07 0 0 0-5 5.16v8.65A5.07 5.07 0 0 0 16 21a5.09 5.09 0 0 0 5-5.16V7.19A5.09 5.09 0 0 0 16 2z"></path><path d="M26 16.38a1 1 0 1 0-1.94 0A7.84 7.84 0 0 1 16 24a7.84 7.84 0 0 1-8-7.62 1 1 0 0 0-1.94 0 9.74 9.74 0 0 0 9 9.52.19.19 0 0 0-.06.1v2h-2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2a.19.19 0 0 0 0-.07 9.74 9.74 0 0 0 9-9.55z"></path>';
var MicrophoneOutlineSVG = function MicrophoneOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MicrophoneOutlineSVG = MicrophoneOutlineSVG;
MicrophoneOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MicrophoneOutlineSVG);
exports.default = _default;